import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Group } from '../../group/domain/group';

import { type AppSelector, UserRole, hasAccessToFeature } from '@/common/application/contextSlice';
export interface pGroup extends Group { admingroup?: Group } 
const initialState: pGroup = {
    defaultDuration: 0,
    groupConfig: {
        groupConfig: [],
        userGroup: {
            name: '',
        }
    },
    guests: [],
    members: [],
    name: '',
    packets: [],
    prefix: '',
    relatesTo: []
};

const holdingSlice = createSlice({
    initialState,
    name: 'holding',
    reducers: {
        clearHolding() {
            return initialState;
        },
        unassignParking(state, action: PayloadAction<number>) {
            const parkings = state.relatesTo?.slice();
            parkings?.splice(action.payload, 1);
            return {
                ...state,
                parkings
            };
        },
        
        removeMemberAdmin(state, action: PayloadAction<number>) {
            const members = state.admingroup?.members?.slice();
            members?.splice(action.payload, 1);
            return {
                ...state,
                admingroup: {
                    ...state.admingroup,
                    members: members
                }
            };
        },
        setCurrentAdminGroup(state, action: PayloadAction<Group>) {
            return { ...state, admingroup: action.payload };
        },
        setHolding(state, action: PayloadAction<Group>) {
            state = action.payload;
            return state;
        },

        
    },
});

export const { setHolding, clearHolding, unassignParking, removeMemberAdmin, setCurrentAdminGroup } = holdingSlice.actions;

export default holdingSlice.reducer;

export const hasAdminRoleInThisGroup = (groupId: number): AppSelector<boolean> => (state) => {

    const userRef = state.auth.user.ref;

    return (() => {
        if (hasAccessToFeature(UserRole.LocalAdmin)(state)) {
            return true;
        }
        if (!userRef) {
            return false;
        }

        let group = state.groups.map[groupId]; // Assuming you have a groups slice with a map of group IDs to group objects

        if (!group || !group.id && groupId == state.group?.id) {
            group = state.group; // Handle case where the group is not found
        }

        if (!group || !group.id) {
            return false; // Handle case where the group is not found
        }

        
        // Return grouo ownership
        const admins = state.groups.adminsLibrary[groupId];


        if (!admins) {
            return false; // Handle case where the group has no admin group
        }

        return admins.members?.some(member => member.user === userRef) ?? false;
    })();

};

export const hasAdminRoleInTheseGroups = (): AppSelector<{ [key: number]: boolean }> => (state) => {
    const map: { [key: number]: boolean } = {};
    state.groups?.list?.forEach(group => typeof group.id !== 'undefined' ? map[group.id] = group.members?.some(member => member.user === state.auth.user.ref) ?? false : null);
    return map;
};